export enum SitePage {
  About = "About",
  Account = "Account",
  Admin = "Admin",
  AppHome = "AppHome",
  Error = "Error",
  Login = "Login",
  Podcasts = "Podcasts",
  Register = "Register",
  Splash = "Splash",
  VCDirectory = "VCDirectory",
  VerifyEmail = "VerifyEmail",
  Unknown = "Unknown",
}
